import * as React from 'react';
import { css } from '@emotion/core';
import { Str } from '../../localization/translationKeys';
import Msg from '../../localization/Msg';
import { COLORS } from '../../globalStyle/colors';
import { Routes } from '../../navigation/routes';
import { CustomResource } from '../resources/models';
import { isDevResources, isTutorialResource, isEBookResource, isECourseResource } from '../resources/module';
import { Link } from 'react-router-dom';
import BulletedMsg from '../../layout/BulletedMsg';
import { faBook } from '@fortawesome/free-solid-svg-icons';


const styles = {
  root:          css`
    
  `,
  title:         css`
    display: block;
    font-size: 11px;
    color: ${COLORS.DARK_GREY};
    margin-bottom: 8px;
    text-transform: uppercase;
  `,
  resourceLinks: css`
    border: 1px solid ${COLORS.LIGHTER_GREY};
    border-radius: 8px;
    
    & > * {
      border-bottom: 1px solid ${COLORS.LIGHTER_GREY};
    }
    
    & > *:last-child {
      border-bottom: none;
    }
  `,
  resourceLink:  css`
    display: block;
    color: ${COLORS.MEDIUM_GREY};
    text-decoration: none;
    padding: 18px 15px;
     
    &:hover {
      background-color: ${COLORS.LIGHTEST_GREY};
    }
  `,
  linkIcon:      css`
    font-size: 15px;
  `,
};

const renderResource = (
  routes: Routes,
  resource: CustomResource): React.ReactNode => {
  if (isDevResources(resource)) {
    return (
      <Link key='DevResources' to={routes.DevResources} css={styles.resourceLink}>
        <BulletedMsg
          icon={faBook}
          msg={Str.DevResources}
          iconStyle={styles.linkIcon}
          spacePx={14}
        />
      </Link>
    );
  }

  if (isECourseResource(resource)) {
    return (
      <Link key='ECourse'
        to={routes.ECourse}
        css={[styles.resourceLink]}
      >
        <BulletedMsg
          icon={faBook}
          msg={Str.ECourse}
          iconStyle={styles.linkIcon}
          spacePx={14}
        />
      </Link>
    );
  }

  if (isEBookResource(resource)) {
    return (
      <Link key='EBook'
        to={routes.EBook}
        css={[styles.resourceLink]}
      >
        <BulletedMsg
          icon={faBook}
          msg={Str.EBook}
          iconStyle={styles.linkIcon}
          spacePx={14}
        />
      </Link>
    );
  }

  if (isTutorialResource(resource)) {
    return (
      <Link key='ReportTutorial' to={routes.ReportTutorial} css={styles.resourceLink}>
        <BulletedMsg
          icon={faBook}
          msg={Str.ReportTutorial}
          iconStyle={styles.linkIcon}
          spacePx={14}
        />
      </Link>
    );
  }

  return (
    <Link
      key={resource.nameMessageId}
      to={routes.CustomResource + '/' + resource.nameMessageId}
      css={styles.resourceLink}
    >
      <BulletedMsg
        icon={faBook}
        msg={resource.nameText}
        iconStyle={styles.linkIcon}
        spacePx={14}
      />
    </Link>
  );
};


type Props = {
  routes: Routes;
  resources: CustomResource[];
  className?: string;
};


/**
 * ResourceMenu: a component that
 *
 * PureComponent: true
 * Redux Connected: false
 */
const ResourceMenu: React.FC<Props> = props => (
  <div css={styles.root} className={props.className}>
    <Msg str={Str.Resources} css={styles.title} />
    <div css={styles.resourceLinks}>
      {
        props.resources.map(res => renderResource(props.routes, res))
      }
    </div>
  </div>
);

export default ResourceMenu;
